import { Box, Typography } from "digiwash-components/src";
import React from "react";

interface PropsType {
  text: string;
  bg?: string;
}

function BannerNotice(props: PropsType) {
  return (
    <Box bg={props.bg ? props.bg : "red.main"} br="l" p="l">
      <Typography color="common.white" ff="mainBold" alignment="center">
        {props.text}
      </Typography>
    </Box>
  );
}

export default BannerNotice;
